export default "__VITE_ASSET__CXRdJVk___"